import { render, staticRenderFns } from "./ExamTakerAnswerDetails.vue?vue&type=template&id=8d0fe9fc&scoped=true"
import script from "./ExamTakerAnswerDetails.vue?vue&type=script&lang=js"
export * from "./ExamTakerAnswerDetails.vue?vue&type=script&lang=js"
import style0 from "./ExamTakerAnswerDetails.vue?vue&type=style&index=0&id=8d0fe9fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0fe9fc",
  null
  
)

export default component.exports